<script>

import { createNamespacedHelpers } from 'vuex';
import {
  ScField,
  ScSelect,
  ScRangeDatePicker,
  ScWarehouseDropdown,
} from '@intelipost-js/secure-components';
import { Moment } from '@intelipost-js/secure-providers';

import useDebounce from '../../shared/FctnDebounce';

const { mapState, mapMutations } = createNamespacedHelpers('recon/billing');

export default {
  name: 'BillingFilterArea',
  watch: {
    selectedDateRange(newDateRange) {
      this.emitRefreshEvent(this.selectedDateSource, newDateRange, this.selectedWarehouseFilter);
    },
    selectedWarehouseFilter(newWarehouseFilter) {
      useDebounce(() => {
        this.emitRefreshEvent(this.selectedDateSource, this.selectedDateRange, newWarehouseFilter);
      }, 500)();
    },
    dateSource(newDateSource) {
      this.emitRefreshEvent(newDateSource, this.selectedDateRange, this.selectedWarehouseFilter);
    },
  },
  methods: {
    ...mapMutations(['setDateSource', 'setDateRange', 'setWarehouseFilter']),
    formatDate(date_range) {
      return {
        start: Moment(date_range.start).format('YYYY-MM-DD'),
        end: Moment(date_range.end).format('YYYY-MM-DD'),
      };
    },
    emitRefreshEvent(dateSource, dateRange, warehouseFilter) {
      const filters = { dateSource, dateRange, warehouseFilter };
      this.$emit('onFilterChange', filters);
    },
  },
  computed: {
    ...mapState(['dateSource', 'dateRange', 'warehouseFilter']),
    warehouseSelectPlaceholder() {
      if (!this.selectedWarehouseFilter || this.selectedWarehouseFilter.length === 0) {
        return 'Centros de distribuição';
      }

      return `Centros de distribuição (${this.selectedWarehouseFilter.length})`;
    },
    selectedDateSource: {
      get() {
        return this.dateSource;
      },
      set(newValue) {
        this.setDateSource(newValue);
      },
    },
    selectedDateRange: {
      get() {
        return this.dateRange;
      },
      set(newValue) {
        this.setDateRange(newValue);
      },
    },
    selectedWarehouseFilter: {
      get() {
        return this.warehouseFilter;
      },
      set(newValue) {
        this.setWarehouseFilter(newValue);
      },
    },
  },
  created() {
    this.emitRefreshEvent(
      this.selectedDateSource,
      this.selectedDateRange,
      this.selectedWarehouseFilter,
    );
  },
  components: { ScField, ScSelect, ScRangeDatePicker, ScWarehouseDropdown },
};
</script>

<template>
  <div style="display: flex; gap: 16px">
    <sc-field>
      <sc-select v-model="selectedDateSource">
        <option key="EXPIRATION_DATE" value="EXPIRATION_DATE">Data de vencimento</option>
        <option key="CREATION_DATE" value="CREATION_DATE">Data de criação</option>
      </sc-select>
    </sc-field>
    <sc-field>
      <sc-range-date-picker
        id="billing-date-picker"
        v-model="selectedDateRange"
        :format="formatDate"
        style="width: 300px"
      />
    </sc-field>

    <sc-field style="width: 260px">
      <sc-warehouse-dropdown
        v-model="selectedWarehouseFilter"
        @selectAll="(values) => selectedWarehouseFilter = values"
        @clearFilter="() => selectedWarehouseFilter = []"
        :customPlaceholder="warehouseSelectPlaceholder"
        list-user
        dropdown
      />
    </sc-field>
  </div>
</template>

<style scoped lang="scss">
@import "~@intelipost-js/secure-ui/src/scss/variables"; //eslint-disable-line
.date-label {
  color: $primary;
}

</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/billing/components/billing-filter-area/BillingFilterArea.vue?3fbf987a